import { request, endpoint } from 'core-request';
import { useClientStore } from '../store/client';

export const instance = request(endpoint.surveyClientService, {
  clientAuth: true,
  client: useClientStore.getState().auth_client,
});
